import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import * as fromQuotes from '../../../quotes/reducers';
import * as LayoutActions from '../../actions/layout.actions';
import {Language} from '../../models/language';
import {Router} from '@angular/router';

@Component({
    selector: 'app-site-menu-page',
    templateUrl: './site-menu-page.component.html',
    styleUrls: ['./site-menu-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteMenuPageComponent {
    @Input()
    isLoggedIn$: Observable<boolean>;
    @Input()
    activatedComponent: object;
    @Input()
    languages: Language[];
    @Input()
    currentLanguage: Language;
    @Output()
    languageSwitched = new EventEmitter<Language>();
    @Output()
    loggedOut = new EventEmitter();

    constructor(
        private store: Store<fromQuotes.State>,
        private router: Router
    ) {}

    onCloseSiteMenu() {
        this.store.dispatch(LayoutActions.closeSiteMenu());
    }

    logout() {
        this.loggedOut.emit();
    }

    search(searchText: string) {
        this.router.navigate(['products', 'search', encodeURIComponent(searchText)]);
    }

    switchLanguage(language: Language) {
        this.languageSwitched.emit(language);
    }
}
